import React, { useEffect, useState } from 'react';

import { Button, Table } from 'react-bootstrap';
import { toast } from 'react-toastify';

import defaultImage from '../../../assets/img/user.png';
import { TeamMemberFormType } from '../enums';
import { ITeamMember } from '../reducers';
import ModalTeamMemberForm from './common/ModalTeamMemberForm';
import edit from '../../../assets/svg/edit.svg';
import { PropsFromReduxMyTeam } from '../containers/MyTeamContainer';
import { defaultTeamMember } from '../props/MyTeamComponentProps';

const MyTeamComponent = (props: PropsFromReduxMyTeam) => {
  const [updateTeamMember, setUpdateTeamMember] = useState<ITeamMember>();

  const [showCreateTeamMember, setShowCreateTeamMember] = useState(false);
  const [showUpdateTeamMember, setShowUpdateTeamMember] = useState(false);

  useEffect(() => {
    props.getTeam();
  }, [props.getTeam]); //eslint-disable-line

  useEffect(() => {
    setShowUpdateTeamMember(true);
  }, [updateTeamMember]);

  useEffect(() => {
    if (!showUpdateTeamMember) {
      setUpdateTeamMember(undefined);
    }
  }, [showUpdateTeamMember]);

  const deleteTeamMember = (teamMember: ITeamMember) => {
    props
      .deleteTeamMember(teamMember)
      .then(() => {
        toast.success('Le collaborateur à été supprimé');
        props.getTeam();
      })
      .catch(() => {
        toast.error('Impossible de supprimé le collaborateur');
      });
  };

  return (
    <div className="bg-container">
      <h1 className="mt-3 fw-bold" style={{ fontSize: '24px', color: '#000D5B' }}>
        Mon équipe - {props.team.label}
      </h1>
      <div className="datagridTable p-2">
        <Table borderless responsive className="h-100">
          <thead className="h-100">
            <tr className="h-100  datagrid-fields">
              <th className="h-100 property-data-grid-th">
                <div className="d-flex align-items-center justify-content-center h-100"></div>
              </th>
              <th className="h-100 property-data-grid-th">
                <div className="d-flex align-items-center justify-content-center h-100">Nom</div>
              </th>
              <th className="h-100 property-data-grid-th">
                <div className="d-flex align-items-center justify-content-center h-100">Téléphone</div>
              </th>
              <th className="h-100 property-data-grid-th">
                <div className="d-flex align-items-center justify-content-center h-100">Email</div>
              </th>
              <th className="h-100 property-data-grid-th">
                <div className="d-flex align-items-center justify-content-center h-100">Fonction</div>
              </th>
              <th className="h-100 property-data-grid-th">
                <div className="d-flex align-items-center justify-content-center h-100">Statut</div>
              </th>
              <th className="h-100 property-data-grid-th">
                <div className="d-flex align-items-center justify-content-center h-100">ACTIONS</div>
              </th>
            </tr>
          </thead>

          <tbody className="property-data-grid mt-3">
            {props.team.members && props.team.members.length > 0 ? (
              props.team.members.map((member: ITeamMember) => (
                <tr key={member.id}>
                  <td>
                    <img
                      src={undefined === member.user?.imagePath ? defaultImage : member.user?.imagePath}
                      alt={member.user.lastname + ' image'}
                      className="img-team"
                    />
                  </td>
                  <td>{`${member.user.firstname} ${member.user.lastname}`}</td>
                  <td>{member.user.phoneNumber}</td>
                  <td>{member.user.email}</td>
                  <td>{member.user?.userInfos?.activityDone?.label || ''}</td>
                  <td>
                    {member?.availability?.isAvailable
                      ? `Indisponible ; motif :${member?.availability?.reasonUnavailabilityType?.label}`
                      : 'Disponible'}
                  </td>
                  <td>
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ visibility: props.user.teamMember?.id === member.id ? 'hidden' : 'visible' }}
                    >
                      <Button
                        className="btn btn-actions btn-edit-order me-1"
                        onClick={() => setUpdateTeamMember(member)}
                      >
                        <img src={edit} alt="edit" style={{ width: '12px', height: '12px' }} />
                      </Button>
                      <Button
                        style={{ width: '26px', height: '26px' }}
                        className="d-flex justify-content-center align-items-center ms-1"
                        variant="danger"
                        onClick={() => deleteTeamMember(member)}
                      >
                        <i style={{ fontSize: '15px' }} className="bi bi-trash"></i>
                      </Button>
                    </div>
                  </td>
                  <td></td>
                </tr>
              ))
            ) : (
              <p className="p-no-property mt-3 ms-2">L'équipe est vide</p>
            )}
          </tbody>
        </Table>
      </div>
      <hr style={{ background: '#bababa', height: '2px' }} />
      <Button
        style={{ height: '48px' }}
        className="mt-5 ms-2 mb-3 d-flex justify-content-center align-items-center"
        onClick={() => setShowCreateTeamMember(true)}
      >
        <i className="bi bi-plus pt-1" style={{ fontSize: '34px' }}></i>Ajouter un collaborateur
      </Button>

      <ModalTeamMemberForm
        actionRequest={props.createTeamMember}
        referentials={props.refetentials}
        reloadTeam={props.getTeam}
        show={showCreateTeamMember}
        setShow={setShowCreateTeamMember}
        team={props.team}
        teamMember={defaultTeamMember}
        type={TeamMemberFormType.CREATE}
      />

      {undefined !== updateTeamMember && (
        <ModalTeamMemberForm
          actionRequest={props.updateTeamMember}
          referentials={props.refetentials}
          reloadTeam={props.getTeam}
          show={showUpdateTeamMember}
          setShow={setShowUpdateTeamMember}
          team={props.team}
          teamMember={updateTeamMember}
          type={TeamMemberFormType.UPDATE}
        />
      )}
    </div>
  );
};

export default MyTeamComponent;
